import { useNavigate } from 'react-router-dom';
import {
  DesktopContainer,
  LoadingSpinner,
} from '@rabbit/elements/shared-components';
import MarketingPreferencesContainer from '../../../../templates/Account/MarketingPreferencesContainer';
import { useMyConsumerPersona } from '@rabbit/data/portal';

function MarketingPreferencesView() {
  const consumerPersona = useMyConsumerPersona();
  const consumerPersonaId = consumerPersona?.personaId;
  const consumerPersonaData = consumerPersona?.data.consumer_private;

  const navigate = useNavigate();

  if (
    consumerPersonaData === null ||
    !consumerPersonaData ||
    !consumerPersonaId
  )
    return <LoadingSpinner size="md" isFullScreen />;

  return (
    <DesktopContainer title="Marketing Preferences" goBack={() => navigate(-1)}>
      <MarketingPreferencesContainer
        id={consumerPersonaId}
        data={consumerPersonaData?.marketing}
      />
    </DesktopContainer>
  );
}

export default MarketingPreferencesView;
